var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { system } from "styled-system";
import { Box } from "./Box";
export var VerticalHierarchy = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  width: 1px;\n  ", "\n  ", "\n"], ["\n  position: absolute;\n  bottom: 0;\n  width: 1px;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        borderLeft: "1px dotted ".concat(theme.colors.text),
    });
}, system({
    hierarchySpace: {
        property: "left",
        scale: "hierarchyPos",
    },
}));
VerticalHierarchy.defaultProps = {
    top: 0,
};
export var HorizontalHierarchy = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 1px;\n  width: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 2px;\n  ", "\n  ", "\n"], ["\n  height: 1px;\n  width: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 2px;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return ({
        borderBottom: "1px dotted ".concat(theme.colors.text),
    });
}, system({
    hierarchySpace: {
        property: "marginLeft",
        scale: "hierarchyMargin",
    },
}));
export var RootHierarchy = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 1px;\n  width: 9px;\n  display: inline-block;\n"], ["\n  height: 1px;\n  width: 9px;\n  display: inline-block;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Hierarchy.js.map